import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { ConstructPost } from '../../types/ConstructPost';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const voidEnvelope = (
  constructPost: ConstructPost,
  envelopeId: string,
  data: Record<string, any>,
): Promise<unknown> =>
  constructPost(
    `${SIGNATURE_BASE_PATH}/envelope/${envelopeId}/void`,
    { data },
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
